<div class="nb-error">
  <div class="error-code">404</div>
  <h3 class="font-bold">We couldn't find the page..</h3>

  <div class="error-desc">
    Sorry, but the page you are looking for was either not found or does not exist. <br/>
    Try refreshing the page or click the button below to go back to the Homepage.
    <p style="margin-top: 15px;">
      <a routerLink="/" class="btn btn-lg btn-outline-primary">Homepage</a>
    </p>
  </div>
</div>
